/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc
 */
import * as References from './MarketplaceListingDetailsRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc#getListingDetailsV2
 */
export const GET_LISTING_DETAILS_V2_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_listing_details_rpc_MarketplaceListingDetailsRpc_getListingDetailsV2';
export const GET_LISTING_DETAILS_V2_QUERY: RegisteredQuery<
  'result',
  References.GetListingDetailsV2RequestType,
  References.GetListingDetailsV2ResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_LISTING_DETAILS_V2_QUERY_FIELD_NAME,
  args: ['slug', 'language'],
  fetcher(
    request: References.GetListingDetailsV2RequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetListingDetailsV2ResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getListingDetailsV2Rpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc#getListingDetailsV3
 */
export const GET_LISTING_DETAILS_V3_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_listing_details_rpc_MarketplaceListingDetailsRpc_getListingDetailsV3';
export const GET_LISTING_DETAILS_V3_QUERY: RegisteredQuery<
  'result',
  References.GetListingDetailsV3RequestType,
  References.GetListingDetailsV3ResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_LISTING_DETAILS_V3_QUERY_FIELD_NAME,
  args: ['slug', 'listingId', 'language'],
  fetcher(
    request: References.GetListingDetailsV3RequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetListingDetailsV3ResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getListingDetailsV3Rpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc#isStandardizedInstall
 */
export const IS_STANDARDIZED_INSTALL_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_listing_details_rpc_MarketplaceListingDetailsRpc_isStandardizedInstall';
export const IS_STANDARDIZED_INSTALL_QUERY: RegisteredQuery<
  'result',
  References.IsStandardizedInstallRequestType,
  References.IsStandardizedInstallResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: IS_STANDARDIZED_INSTALL_QUERY_FIELD_NAME,
  args: ['listingId'],
  fetcher(
    request: References.IsStandardizedInstallRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.IsStandardizedInstallResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.isStandardizedInstallRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc#getAppFeaturesBatch
 */
export const GET_APP_FEATURES_BATCH_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_listing_details_rpc_MarketplaceListingDetailsRpc_getAppFeaturesBatch';
export const GET_APP_FEATURES_BATCH_QUERY: RegisteredQuery<
  'result',
  References.GetAppFeaturesBatchRequestType,
  References.GetAppFeaturesBatchResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_APP_FEATURES_BATCH_QUERY_FIELD_NAME,
  args: ['appIds', 'language'],
  fetcher(
    request: References.GetAppFeaturesBatchRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetAppFeaturesBatchResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getAppFeaturesBatchRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc#getListingSupplement
 */
export const GET_LISTING_SUPPLEMENT_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_listing_details_rpc_MarketplaceListingDetailsRpc_getListingSupplement';
export const GET_LISTING_SUPPLEMENT_QUERY: RegisteredQuery<
  'result',
  References.GetListingSupplementRequestType,
  References.GetListingSupplementResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_LISTING_SUPPLEMENT_QUERY_FIELD_NAME,
  args: ['productType', 'sourceId'],
  fetcher(
    request: References.GetListingSupplementRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetListingSupplementResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getListingSupplementRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc#getListingSupplementBatch
 */
export const GET_LISTING_SUPPLEMENT_BATCH_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_listing_details_rpc_MarketplaceListingDetailsRpc_getListingSupplementBatch';
export const GET_LISTING_SUPPLEMENT_BATCH_QUERY: RegisteredQuery<
  'result',
  References.GetListingSupplementBatchRequestType,
  References.GetListingSupplementBatchResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_LISTING_SUPPLEMENT_BATCH_QUERY_FIELD_NAME,
  args: ['productType', 'sourceIds'],
  fetcher(
    request: References.GetListingSupplementBatchRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetListingSupplementBatchResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getListingSupplementBatchRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc#getAppReleaseHistory
 */
export const GET_APP_RELEASE_HISTORY_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_listing_details_rpc_MarketplaceListingDetailsRpc_getAppReleaseHistory';
export const GET_APP_RELEASE_HISTORY_QUERY: RegisteredQuery<
  'result',
  References.GetAppReleaseHistoryRequestType,
  References.GetAppReleaseHistoryResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_APP_RELEASE_HISTORY_QUERY_FIELD_NAME,
  args: ['slug'],
  fetcher(
    request: References.GetAppReleaseHistoryRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetAppReleaseHistoryResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getAppReleaseHistoryRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
